import { FlowFileConversionFormat, FlowFileConversionOperation } from 'flow-schema';

import { api } from 'common';

import { FileConversionFormFields } from './FormFields';
import { FileConversionOutputContent } from './OutputContent';
import { FileConversionBlockDocumentation } from './documentation';
import { type BlockConfigProps } from '../../types';

type FileConversionBlockConfig = api.FlowDefinition.FileConversionBlock['config'];

export const fileConversionBlockConfig: BlockConfigProps<FileConversionBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'transformFile',
  defaultConfig: {
    operation: FlowFileConversionOperation.Convert,
    format: FlowFileConversionFormat.Base64,
    fileReference: '',
  },
  configFields: {
    schema: api.FlowDefinition.FileConversionBlockConfigSchema,
    FormFields: FileConversionFormFields,
  },
  OutputContentComponent: FileConversionOutputContent,
  documentationMarkdown: FileConversionBlockDocumentation,
};
